import React from "react";

// components
import Header from "./Header";
import Artist from "./Artist";
import Meta from "./Meta";
import Buttons from "./Buttons";
import Attribution from "./Attribution";
import Footer from "./Footer";

// styles
import { SidebarColGridItem, InnerContentStyled } from "../styles";

export const Sidebar = ({ children }) => {
    return (
        <SidebarColGridItem item sm={12} md={4} lg={4}>
            <InnerContentStyled>
                <Header />
                <Artist />
                <Meta />
                <Buttons>{children}</Buttons>
                <Attribution />
                <Footer />
            </InnerContentStyled>
        </SidebarColGridItem>
    );
};
